function SubscriptionPageMain() {
    return (
        <main className="carbon-pattern pb-20 mt-[60px]">
            <div className="max-w-4xl mx-auto px-6 pt-16 pb-12 text-center">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-[10px] font-bold uppercase tracking-[0.2em] mb-6">
                    <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                    </span>
                    Engineering Mode Active
                </div>
                <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">Choose Your Performance Tier</h2>
                <p className="text-slate-500 dark:text-slate-400 text-lg max-w-2xl mx-auto">
                    Professional-grade telemetry tools designed for serious sim racers and race engineers. Zero latency, maximum precision.
                </p>
            </div>
            <div className="max-w-5xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
                <div className="bg-white dark:bg-surface-dark border border-slate-200 dark:border-border-dark p-8 rounded-xl flex flex-col hover:border-slate-300 dark:hover:border-slate-700 transition-all group">
                    <div className="mb-8">
                        <h3 className="text-xl font-bold uppercase tracking-wide mb-2">Basic</h3>
                        <div className="flex items-baseline gap-1">
                            <span className="text-5xl font-black tabular-nums tracking-tighter">$0</span>
                            <span className="text-slate-500 font-medium">/MONTH</span>
                        </div>
                        <p className="mt-4 text-sm text-slate-500 dark:text-slate-400">Essential telemetry for enthusiasts starting their journey.</p>
                    </div>
                    <div className="space-y-4 mb-10 flex-grow">
                        <div className="flex items-start gap-3">
                            <span className="material-symbols-outlined text-primary text-xl">check_circle</span>
                            <span className="text-sm font-medium">Real-time Telemetry Data</span>
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="material-symbols-outlined text-primary text-xl">check_circle</span>
                            <span className="text-sm font-medium">Local Client Access</span>
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="material-symbols-outlined text-primary text-xl">check_circle</span>
                            <span className="text-sm font-medium">24h Session History</span>
                        </div>
                        <div className="flex items-start gap-3 opacity-30 grayscale">
                            <span className="material-symbols-outlined text-slate-400 text-xl">block</span>
                            <span className="text-sm font-medium">Race Engineer Mode</span>
                        </div>
                        <div className="flex items-start gap-3 opacity-30 grayscale">
                            <span className="material-symbols-outlined text-slate-400 text-xl">block</span>
                            <span className="text-sm font-medium">Cloud MoTeC Storage</span>
                        </div>
                    </div>
                    <button className="w-full py-4 px-6 rounded-lg bg-slate-100 dark:bg-border-dark hover:bg-slate-200 dark:hover:bg-slate-800 text-sm font-bold uppercase tracking-widest transition-all">
                        Get Started
                    </button>
                </div>
                <div className="relative bg-white dark:bg-surface-dark border-2 border-primary p-8 rounded-xl flex flex-col shadow-2xl shadow-primary/20 transform md:scale-105">
                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-white text-[10px] font-black uppercase tracking-[0.2em] px-4 py-1.5 rounded-full">
                        Most Popular
                    </div>
                    <div className="mb-8">
                        <div className="flex justify-between items-start">
                            <h3 className="text-xl font-bold uppercase tracking-wide mb-2 text-primary">Pro</h3>
                            <span className="material-symbols-outlined text-primary">settings_input_component</span>
                        </div>
                        <div className="flex items-baseline gap-1">
                            <span className="text-5xl font-black tabular-nums tracking-tighter">$12</span>
                            <span className="text-slate-500 font-medium">/MONTH</span>
                        </div>
                        <p className="mt-4 text-sm text-slate-500 dark:text-slate-400">Advanced analysis and real-time collaboration for competitive teams.</p>
                    </div>
                    <div className="space-y-4 mb-10 flex-grow">
                        <div className="flex items-start gap-3">
                            <span className="material-symbols-outlined text-primary text-xl">check_circle</span>
                            <div className="flex flex-col">
                                <span className="text-sm font-bold">Race Engineer Mode</span>
                                <span className="text-[11px] text-slate-500 dark:text-slate-400">Share live telemetry data with your crew</span>
                            </div>
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="material-symbols-outlined text-primary text-xl">check_circle</span>
                            <span className="text-sm font-bold">Unlimited Session History</span>
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="material-symbols-outlined text-primary text-xl">check_circle</span>
                            <span className="text-sm font-bold">Cloud MoTeC Storage</span>
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="material-symbols-outlined text-primary text-xl">check_circle</span>
                            <span className="text-sm font-bold">Priority Tech Support</span>
                        </div>
                        <div className="flex items-start gap-3">
                            <span className="material-symbols-outlined text-primary text-xl">check_circle</span>
                            <span className="text-sm font-bold">Multi-screen Dashboard Support</span>
                        </div>
                    </div>
                    <button className="w-full py-4 px-6 rounded-lg bg-primary hover:bg-primary/90 text-white text-sm font-bold uppercase tracking-widest shadow-lg shadow-primary/30 transition-all active:scale-[0.98]">
                        Upgrade Now
                    </button>
                </div>
            </div>
            <div className="max-w-4xl mx-auto px-6 mt-32">
                <div className="flex items-center gap-4 mb-10">
                    <div className="h-px flex-grow bg-slate-200 dark:bg-border-dark"></div>
                    <h2 className="text-2xl font-bold uppercase tracking-widest text-slate-400">Technical FAQ</h2>
                    <div className="h-px flex-grow bg-slate-200 dark:bg-border-dark"></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="space-y-2">
                        <h4 className="font-bold text-lg flex items-center gap-2">
                            <span className="material-symbols-outlined text-primary">help</span>
                            How does live sharing work?
                        </h4>
                        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
                            Race Engineer Mode generates a secure, unique session token. Your engineer can input this token into their ACCLive client to view your car's data with less than 50ms latency.
                        </p>
                    </div>
                    <div className="space-y-2">
                        <h4 className="font-bold text-lg flex items-center gap-2">
                            <span className="material-symbols-outlined text-primary">cloud_done</span>
                            What is Cloud MoTeC Storage?
                        </h4>
                        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
                            Instead of managing local files, we automatically sync your .ld and .ldp files to our encrypted servers. Access your laps from any workstation instantly.
                        </p>
                    </div>
                    <div className="space-y-2">
                        <h4 className="font-bold text-lg flex items-center gap-2">
                            <span className="material-symbols-outlined text-primary">account_balance_wallet</span>
                            Can I cancel anytime?
                        </h4>
                        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
                            Yes. Subscriptions are billed monthly. If you cancel, you will maintain Pro access until the end of your current billing cycle, then revert to Basic.
                        </p>
                    </div>
                    <div className="space-y-2">
                        <h4 className="font-bold text-lg flex items-center gap-2">
                            <span className="material-symbols-outlined text-primary">memory</span>
                            Is there any FPS impact?
                        </h4>
                        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
                            Our client is highly optimized for low CPU overhead. It typically uses less than 0.5% of a modern CPU, ensuring no impact on your racing performance.
                        </p>
                    </div>
                </div>
            </div>
            <div className="max-w-7xl mx-auto px-6 mt-20">
                <div className="bg-surface-dark border border-border-dark rounded-xl p-6 flex flex-col md:flex-row items-center justify-between gap-6">
                    <div className="flex items-center gap-4">
                        <div className="size-12 rounded bg-border-dark flex items-center justify-center">
                            <span className="material-symbols-outlined text-primary">contact_support</span>
                        </div>
                        <div>
                            <p className="text-sm font-bold uppercase tracking-tight">Need a Team License?</p>
                            <p className="text-xs text-slate-400">Custom solutions for eSports teams and professional sim-racing leagues.</p>
                        </div>
                    </div>
                    <button className="px-6 py-2.5 border border-primary text-primary text-xs font-bold uppercase tracking-widest hover:bg-primary hover:text-white transition-all">
                        Contact Sales
                    </button>
                </div>
            </div>
        </main>
    );
}

export default SubscriptionPageMain;